import { batch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as swissknife from 'up.lib.js.swissknife';
import { Endpoint } from '~src/domains/common/enums/api';
import { Country, Currency } from '~src/domains/common/enums/localization';
import {
  general,
  setSecureForms,
} from '~src/domains/common/state/commonReducer';
import { StateObject } from '~src/domains/common/types/common';
import { trackBinXhr, trackBinXhrResult, trackXhrResult } from './tracking';
import { xhrNext } from './xhr';

require('../external/lib/checkout.min.js');

const secureForms = (window as any).up.lib.cljs.secure_forms.checkout;

const defaultPaymentConfig = {
  forms: {
    number: {
      selector: '#card-info-number',
      title: 'Secure card number input',
    },
    ccv: {
      selector: '#card-info-ccv',
      title: 'Secure card C C V input',
    },
    expiration: {
      selector: '#card-info-expiration',
      title: 'Secure card expiration input',
    },
    zip: {
      selector: '#billing-zip',
      title: 'Secure billing zipcode input',
    },
  },
  forms_style: {
    input: 'width: 100%; height: 100%; padding: 6px 12px; font-size: 16px;',
  },
};

const initSecureForms =
  (id: string, url: string, config: Object) =>
  (
    dispatch: ThunkDispatch<StateObject, unknown, Action<string>>,
    getState: Function,
  ) => {
    const state = getState();

    if (state.common.secureForms.initialized) {
      return;
    }

    dispatch(
      setSecureForms({
        initialized: true,
      }),
    );

    const secureFormsAuthSuccess = () => {
      const { next, secureForms } = state.common;

      if (!secureForms.dispatched) {
        dispatch(
          trackXhrResult(
            next,
            200,
            'No mcode in secure forms auth-ok',
            Endpoint.ACCEPT,
          ),
        );
      }

      batch(() => {
        dispatch(
          setSecureForms({
            dispatched: true,
          }),
        );
        dispatch(
          general({
            mcode: null,
            next: Endpoint.ACCEPT,
          }),
        );
      });

      dispatch(xhrNext({ forceNext: Endpoint.ACCEPT }));
    };

    const secureFormsAuthFail = (mcode: number) => {
      const state = getState();
      const errorCode = mcode ?? 18;

      dispatch(
        trackXhrResult(
          state.common.next,
          400,
          errorCode,
          'card not authorized',
        ),
      );
      dispatch(
        general({
          mcode: errorCode,
          isProcessing: false,
        }),
      );
    };

    const secureFormsTrackBinXhr = () => {
      dispatch(trackBinXhr());
    };

    const secureFormsTrackBinXhrResult = (
      status: string,
      valid: boolean,
      mcode: number,
    ) => {
      dispatch(trackBinXhrResult(status, valid, mcode));
    };

    const paymentConfig = {
      auth_ok: secureFormsAuthSuccess,
      auth_fail: secureFormsAuthFail,
      track_bin_xhr: secureFormsTrackBinXhr,
      track_bin_xhr_result: secureFormsTrackBinXhrResult,
      upcode: state.common.upcode,
    };

    swissknife.deepAssignObj(paymentConfig, defaultPaymentConfig);
    swissknife.deepAssignObj(paymentConfig, config);

    secureForms.setup('card', id, url, paymentConfig);
  };

const paySecureForms = (name: string, currency: Currency) => {
  secureForms.pay('card', {
    name,
    currency,
  });
};

const resetSecureForms = () => {
  secureForms.reset();
};

export { secureForms, initSecureForms, paySecureForms, resetSecureForms };
